import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../components';

const ProfilePicWrapper = ({ imagePath, onDelete }) => {
	return (
		<div className="current-pic">
			<img src={imagePath} />
			<Button danger title="Delete" onClick={onDelete} className="delete" />
		</div>
	);
};

ProfilePicWrapper.propTypes = {
	imagePath: PropTypes.string,
	onDelete: PropTypes.func
};

export default ProfilePicWrapper;
